import React from "react";
import { OverlayForm } from "playground/cms/Form";
import MediaSetContainer from "./MediaSet.container";

//import PropTypes from 'prop-types';

export function MediaSetPopup(props) {
    const { id, onClose } = props;
    return (
        <OverlayForm
            open={!!id}
            onClose={onClose}
            position={"center"}
            fullHeight={false}
            width={"md"}
            zIndex={7}
        >
            <MediaSetContainer {...props} />
        </OverlayForm>
    );
}

MediaSetPopup.propTypes = {};

MediaSetPopup.defaultProps = {};

export default MediaSetPopup;
